import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

interface FormDialogProps {
	title: string;
	open: boolean;
	toggleDialog: (open: boolean) => void;
	handleProceed: () => void;
	actions?: boolean;
	children?: any;
}

const FormDialog = (props: FormDialogProps) => {
	const { toggleDialog, open, title, actions } = props;
	const handleClose = () => {
		toggleDialog(false);
	};
	return (
		<div style={{display: 'flex'}}>
			<Dialog 
				open={open} 
				onClose={handleClose} 
				scroll="paper"
				aria-labelledby="scroll-dialog-title"
				aria-describedby="scroll-dialog-description"
				style={{width: '100%'}}>
				<DialogTitle sx={{paddingLeft: '2rem'}} id="scroll-dialog-title">{title}</DialogTitle>
				{props.children && <DialogContent
					id="scroll-dialog-description"
					dividers={true}>
					{props.children}
				</DialogContent>
				}
				{actions && 
					<DialogActions sx={{m:2}}>
						<Button color="error" variant="outlined" onClick={handleClose}>Cancel</Button>
						<Button color="success" variant="contained" onClick={props.handleProceed}>Proceed</Button>
					</DialogActions>
				}
			</Dialog>
		</div>
	);
}
export default FormDialog;

